@import "../../../../../shared/styles/base";

.ds-tooltip {
  $arrow-size: 10px;

  background-color: $ds-violet-900;
  border-radius: 4px;
  color: $white;
  font-size: $ds-font-size-b3;
  padding: 0.5rem 0.75rem;
  transition: opacity 0.25s ease-in, visibility 0.25s;
  opacity: 0;
  visibility: hidden;
  width: max-content;
  pointer-events: none;

  &.is-visible {
    opacity: 1;
    visibility: visible;
  }

  &::before {
    border-style: solid;
    border-width: $arrow-size;
    border-color: transparent $ds-violet-900 transparent transparent;
    content: "";
    position: absolute;
    left: -2 * $arrow-size;
    top: calc(50% - 10px);
  }

  p {
    margin-bottom: 0.75rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.c-popup--x-before .ds-tooltip::before {
  right: 1px;
  transform: rotate(180deg) translateX(-100%);
}

.c-popup--y-before .ds-tooltip::before {
  top: 100%;
  left: 50%;
  transform: rotate(-90deg) translateY(-50%);
}

.c-popup--y-after .ds-tooltip::before {
  top: 0;
  left: 50%;
  transform: rotate(90deg) translateX(-100%) translateY(50%);
}
